import {type PartialOptions, UI} from "../../../../../../stem-core/ui/UIBase";

import {ConfirmationModal} from "../../../../../ui/ConfirmationModal.jsx";
import {AddressForm, type AddressFieldErrors} from "../../../../../common/AddressForm.jsx";
import {Messages} from "../../../../../Messages.js";
import {wrapInSpinner} from "../../../../../../core/ui/LoadingSpinner.jsx";
import {Subscription} from "../../../../../../client/state/SubscriptionStore.js";
import {UserAddress} from "../../../../../../client/state/UserAddressStore.js";
import {apiEditAddress} from "../../../../../../client/state/UserAddressStore.js";
import {autoredraw} from "../../../../../../stem-core/decorators/AutoRedraw";
import {Toast} from "../../../../../ui/Toast.jsx";


interface EditAddressModalOptions {
    address?: UserAddress;
}

@autoredraw(Subscription, UserAddress)
export class EditAddressModal extends ConfirmationModal<EditAddressModalOptions> {
    declare form: AddressForm;

    getDefaultOptions(): PartialOptions<EditAddressModal> {
        return {
            ...super.getDefaultOptions(),
            address: null,
            confirmLabel: Messages.editAddress,
            title: Messages.editAddress,
            confirmAction: () => this.editAddress(),
        };
    }

    @wrapInSpinner
    async editAddress() {
        const validInputs = this.form && this.form.validateInputs();
        if (!validInputs || !this.options.address) {
            return;
        }

        try {
            await apiEditAddress({
                ...this.form.getValues(),
                userAddressId: this.options.address.id
            });
            this.hide();
        } catch (error) {
            this.onErrorResponseReceived(error)
        }
    }

    onErrorResponseReceived(errorResponse: AddressFieldErrors) {
        this.form.displayFieldErrors(errorResponse);
        const nonFieldError = errorResponse.fields?.find(fieldError => fieldError.field === "non_field_errors");

        if (nonFieldError) {
            Toast.showError(nonFieldError);
        }
    }

    render() {
        return <AddressForm ref="form" address={this.options.address}/>;
    }
}
